/* eslint-disable camelcase */

import React, { useEffect, useState, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import Select from 'react-select'
import styled from 'styled-components'
import { ToastContainer, toast } from 'react-toastify'

import countriesList from 'all-countries-and-cities-json'

import { H2 } from '../../../../style/Typography.style'

import Flex from '../../../../components/layouts/Flex'
import DashboardInput from '../../../../components/dashboard/DashboardInput'
import { SingleDropdownSelect } from '../../../../components/dashboard/TalentPool/DropdownSelect'
import { JobToggleButton } from '../../../../components/dashboard/ToggleButton'
import { FilterCheckBox } from '../../../../components/dashboard/FilterInput'
import RichTextbox from '../../../../components/dashboard/controls/RichTextBox'
import DashboardButton from '../../../../components/dashboard/DashboardButton'

import SingleVacancyTypeSelect from '../../../../components/CustomSelect/SingleVacancyTypeSelect'

import {
  SET_ACTIVE_VACANCY,
  SET_COMPANY_ID,
  SET_JOB_DESCRIPTION,
  SET_JOB_TITLE,
  SET_COMP_DATE,
  SET_JOB_TYPE,
  SET_POC_ID,
  SET_POLLING,
  SET_REACH_STEP,
  SET_REQUIRES_COACHING,
  SET_PRIORITY,
  SET_TIME_SHIFT,
  SET_VACANCY_FOR_POOLING,
  SWITCH_STEP,
  SET_AVAILABLE_COUNTRIES,
  SET_INDUSTRY,
} from '../../../../store/types/jobPosting'

import {
  setRecruiterId,
  setRecruitmentType,
  setVacancyType,
} from '../../../../store/actions/jobPostingActions'

import useFetch from '../../../../hooks/useFetch'

import axiosInstance from '../../../../services/config/AxiosIntance'

const JobDetails = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { data: recruiters } = useFetch('/recruiters')
  const { data: recruitmentTypes } = useFetch('/recruitment-types')

  const {
    polling,
    requires_coaching,
    priority,
    description,
    title,
    target_comp_date,
    job_type,
    active_vacancy,
    vacancy_for_pooling,
    time_shift,
    client,
    poc_id,
    company_id,
    recruiter_id,
    countries,
    industry_id,
    recruitment_type_id,
    vacancy_type_id,
    vacancy_type_name,
  } = useSelector((state) => state.jobPosting)

  const [companies, setCompanies] = useState([])
  const [contacts, setContacts] = useState([])
  const [allCountries, setCountries] = useState([])
  const [industries, setIndustries] = useState([])

  useMemo(() => {
    Object.keys(countriesList)?.forEach((country) => {
      setCountries((allCountries) => [
        ...allCountries,
        { value: country, label: country },
      ])
    })
    return allCountries
  }, [countriesList])

  useEffect(() => {
    axiosInstance.get('/company?client_status_id=1').then((response) => {
      setCompanies(response?.data?.data)
    })
    axiosInstance.get('/industries').then((response) => {
      setIndustries(response?.data?.result)
    })
  }, [])

  useEffect(() => {
    if (company_id) {
      axiosInstance
        .get(`/poc?company_id=${company_id}&status_id=1`)
        .then((response) => {
          setContacts(response?.data?.data)
        })
    }
  }, [company_id])

  // handle pooling
  const handlePooling = () => {
    dispatch({ type: SET_POLLING })
    dispatch({
      type: SET_VACANCY_FOR_POOLING,
      payload: 0,
    })
  }

  const handleDescription = (value) => {
    dispatch({ type: SET_JOB_DESCRIPTION, payload: value })
  }

  const handleCancelJobPost = (e) => {
    navigate('/job-listing')
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    axiosInstance.get(`/job?title=${title}&status=active`).then((response) => {
      const existingJobs = response?.data?.data

      if (title === '')
        return toast('Please enter a job title', { type: 'error' })

      if (existingJobs.length > 0)
        return toast(
          'There is already an existing active job with the same title.',
          { type: 'error' }
        )

      if (target_comp_date === undefined)
        return toast('Please enter a Target completion date', {
          type: 'error',
        })
      if (description === '')
        return toast('Please enter a job summary', { type: 'error' })
      if (job_type === '')
        return toast('Please select an employment type', { type: 'error' })
      if (active_vacancy === '')
        return toast('Please enter a active vacancy', { type: 'error' })
      if (client === '')
        return toast('Please select a client', { type: 'error' })
      if (time_shift === '')
        return toast('Please select a time shift', { type: 'error' })
      if (recruitment_type_id && recruitment_type_id === '')
        return toast('Please select a recruitment type', {
          type: 'error',
        })
      if (vacancy_type_id && vacancy_type_id === '')
        return toast('Please select a vacancy type', {
          type: 'error',
        })

      if (recruiter_id === '')
        return toast('Please select a recruiter', { type: 'error' })
      if (poc_id === '' || poc_id === null)
        return toast('Please select a point of contact', { type: 'error' })
      if (countries === undefined)
        return toast('Please select atleast one country', { type: 'error' })

      dispatch({ type: SWITCH_STEP, payload: 2 })
      dispatch({ type: SET_REACH_STEP, payload: 2 })

      localStorage.setItem('reachedStep', 2)
      localStorage.setItem('step', 2)
      localStorage.setItem(
        'jobDetails',
        JSON.stringify({
          polling,
          requires_coaching,
          priority,
          description,
          title,
          target_comp_date,
          job_type,
          active_vacancy,
          vacancy_for_pooling,
          time_shift,
          client,
          company_id,
          poc_id,
          recruiter_id,
          countries,
        })
      )
    })
  }

  const handleClientChange = (e) => {
    const client = companies.find(
      (client) => client.name.toString() === e.target.value
    )
    dispatch({
      type: SET_COMPANY_ID,
      payload: JSON.stringify(client),
    })
  }

  const handleContactChange = (e) => {
    const contact = contacts.find(
      (contact) => contact.id.toString() === e.target.value
    )
    dispatch({
      type: SET_POC_ID,
      payload: JSON.stringify(contact),
    })
  }

  const handleIndustryChange = (e) => {
    const industry = industries.find(
      (el) => el.id.toString() === e.target.value
    )

    dispatch({
      type: SET_INDUSTRY,
      payload: JSON.stringify(industry),
    })
  }

  const handleRecruitmentTypeChange = (e) => {
    const recruitmentType = recruitmentTypes?.result?.find(
      (el) => el.id.toString() === e.target.value
    )

    dispatch(setRecruitmentType(recruitmentType))
  }

  const handleVacancyTypeChange = (e) => {
    dispatch(setVacancyType(e))
  }

  return (
    <Flex
      margin="2.5rem 1rem 9rem 1rem"
      direction="column"
      width="100%"
      maxw="500px"
      maxwMobile="300px"
    >
      <H2>Job Details</H2>
      <DashboardInput
        label="Job Title"
        placeholder="e.g. Graphic Designer, Software Engineer"
        name="jobTitle"
        handleChange={(e) =>
          dispatch({ type: SET_JOB_TITLE, payload: e.target.value })
        }
        type="text"
        value={title}
        height="2.5rem"
      />
      <DashboardInput
        label="Target Completion Date"
        name="targetDate"
        handleChange={(e) =>
          dispatch({ type: SET_COMP_DATE, payload: e.target.value })
        }
        type="date"
        value={target_comp_date}
        height="2.5rem"
        min={new Date().toISOString().split('T')[0]}
      />
      {/* Engagement type field needs options and state created */}
      <SingleDropdownSelect
        onChange={(e) =>
          dispatch({ type: SET_JOB_TYPE, payload: e.target.value })
        }
        value={job_type}
        title="Engagement type"
      >
        <option>Choose an option</option>
        <option value="full-time">Full time</option>
        <option value="part-time">Part time</option>
      </SingleDropdownSelect>

      {/* creating double type input box */}
      <Flex width="100%" mobileDirection="column">
        <FilterCheckBox
          checked={polling}
          size="small"
          pos="absolute"
          top="-.05rem"
          right="-1.75rem"
          label="For Pooling"
          name="ProfessionalHeadline"
          onChange={handlePooling}
        />
        <DashboardInput
          label="Active Vacancies"
          placeholder={0}
          value={active_vacancy}
          handleChange={(e) => {
            if (e.target.value < 0) return
            dispatch({ type: SET_ACTIVE_VACANCY, payload: e.target.value })
          }}
          name="activeVacancies"
          type="number"
          height="2.5rem"
        />
        {polling && (
          <DashboardInput
            label="Vacancy for Pooling"
            placeholder={0}
            value={vacancy_for_pooling}
            handleChange={(e) => {
              if (e.target.value < 0) return
              dispatch({
                type: SET_VACANCY_FOR_POOLING,
                payload: e.target.value,
              })
            }}
            name="vacancyForPooling"
            type="number"
            height="2.5rem"
          />
        )}
      </Flex>

      <SingleDropdownSelect
        onChange={(e) =>
          dispatch({ type: SET_TIME_SHIFT, payload: e.target.value })
        }
        value={time_shift}
        title="Time Shift"
      >
        <option>Choose an option</option>
        <option value="Morning Shift - PH TIME">Morning Shift - PH TIME</option>
        <option value="Afternoon Shift - PH TIME">
          Afternoon Shift - PH TIME
        </option>
        <option value="Night Shift - PH TIME">Night Shift - PH TIME</option>
        <option value="Rotational Shift - PH TIME">
          Rotational Shift - PH TIME
        </option>
      </SingleDropdownSelect>

      {/*  */}

      <RichTextbox
        label="Job Summary"
        removeButtons={[
          'paragraph',
          'bold',
          'underline',
          'italic',
          '|',
          'ul',
          'ol',
          '|',
          'link',
          '|',
          'undo',
          'redo',
        ]}
        content={description}
        setContent={handleDescription}
      />

      <SingleDropdownSelect
        onChange={(e) => dispatch(setRecruiterId(e.target.value))}
        title="Recruiter"
        value={recruiter_id}
      >
        <option value="">Choose an option</option>
        {recruiters?.resp?.map((recruiter) => {
          if (recruiter?.Recruiter?.name) {
            return (
              <option
                key={recruiter?.Recruiter?.user_id}
                value={recruiter?.Recruiter?.user_id}
              >
                {recruiter?.Recruiter?.name}
              </option>
            )
          }
          return null
        })}
      </SingleDropdownSelect>

      <SingleDropdownSelect
        onChange={handleRecruitmentTypeChange}
        title="Recruitment Type"
        value={recruitment_type_id}
      >
        <option value="">Choose an option</option>
        {recruitmentTypes?.result?.map((recruitmentType) => {
          return (
            <option key={recruitmentType?.id} value={recruitmentType?.id}>
              {recruitmentType?.name}
            </option>
          )
        })}
      </SingleDropdownSelect>

      <SingleVacancyTypeSelect
        vacancyType={{ value: vacancy_type_id, label: vacancy_type_name }}
        onSelectVacancyType={handleVacancyTypeChange}
      />

      <SingleDropdownSelect
        onChange={handleClientChange}
        title="Client"
        value={client}
      >
        <option>Choose an option</option>
        {companies?.map((item) => (
          <option key={item.id} value={item.name}>
            {item.name}
          </option>
        ))}
      </SingleDropdownSelect>

      <SingleDropdownSelect
        onChange={handleContactChange}
        title="Point of Contact"
        value={poc_id}
      >
        <option>Choose an option</option>
        {contacts?.map((item) => (
          <option key={item.id} value={item.id}>
            {item.name}
          </option>
        ))}
      </SingleDropdownSelect>

      <SingleDropdownSelect
        onChange={handleIndustryChange}
        title="Industry"
        value={industry_id}
      >
        <option>Choose an option</option>
        {industries?.map((item) => (
          <option key={item.id} value={item.id}>
            {item.name}
          </option>
        ))}
      </SingleDropdownSelect>

      <MultiSelectWrapper>
        <label>Vacancy available on countries</label>
        <Select
          placeholder="Select from the options to add more..."
          menuPortalTarget={document.body}
          styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
          className="slider"
          options={allCountries}
          value={countries}
          onChange={(value) =>
            dispatch({ type: SET_AVAILABLE_COUNTRIES, payload: value })
          }
          isMulti
        />
      </MultiSelectWrapper>

      {/* Toggle button */}
      <JobToggleButton
        value={requires_coaching}
        onClick={() => dispatch({ type: SET_REQUIRES_COACHING })}
        label="This listing requires coaching"
        mt=".875rem"
        mb="1.5rem"
      />
      <JobToggleButton
        value={priority}
        onClick={() => dispatch({ type: SET_PRIORITY })}
        label="Set as priority"
        mt=".875rem"
        mb="1.5rem"
      />

      {/*  submit button */}
      <Flex width="100%" justify="flex-end">
        <DashboardButton
          text="Cancel"
          onClick={handleCancelJobPost}
          rounded
          notIcon
          marginRight={'5px'}
        />
        <DashboardButton
          text="Next Step"
          onClick={handleSubmit}
          rounded
          notIcon
        />
      </Flex>
      <ToastContainer
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </Flex>
  )
}

export default JobDetails

export const MultiSelectWrapper = styled.div`
  width: ${({ width }) => width || '100%'};
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 0.75rem;

  label {
    font-size: 0.75rem;
    color: #31374f;
    font-weight: 300;
  }

  .slider {
    width: 100%;

    .css-1s2u09g-control {
      border: 1px solid #aeb3c9;
      background-color: #fff;
      border-radius: 0;
      /* padding: 1rem; */
      font-size: 0.75rem;
      font-weight: 300;
    }

    .css-1pahdxg-control {
      border: 1px solid #1a1a1a;
      box-shadow: 0 0 0 1px #1a1a1a;
      border-radius: 0;
      font-size: 0.75rem;
      font-weight: 300;
    }

    .css-1rhbuit-multiValue {
      background-color: #f2f3f8;
      border-radius: 3px;
    }
  }
`
